/**
 * LogstashPipe - Bibliothèque pour envoyer des logs à Logstash
 *
 * Cette bibliothèque capture les erreurs JavaScript et les envoie à Logstash
 * via une requête HTTP.
 */

class LogstashPipe {
  constructor(options = {}) {
    this.logstashUrl = options.logstashUrl || "https://elk.leslipfrancais.fr";
    this.appName = options.appName || "javascript_app";
    this.environment = options.environment || "production";
    this.initialized = false;
  }

  /**
   * Initialise le pipe et configure les gestionnaires d'événements
   */
  init() {
    if (this.initialized) return;

    // Capturer les erreurs non gérées
    window.addEventListener("error", (event) => {
      this.logError({
        type: "uncaught_error",
        message: event.message,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        error: event.error
          ? {
              name: event.error.name,
              message: event.error.message,
              stack: event.error.stack,
            }
          : null,
      });
    });

    // Capturer les rejets de promesses non gérés
    window.addEventListener("unhandledrejection", (event) => {
      this.logError({
        type: "unhandled_rejection",
        reason: event.reason ? event.reason.toString() : "Unknown reason",
        stack: event.reason && event.reason.stack ? event.reason.stack : null,
      });
    });

    this.initialized = true;
    console.log("LogstashPipe initialisé");
  }

  /**
   * Envoie une erreur à Logstash
   * @param {Object} errorData - Données de l'erreur à envoyer
   */
  async logError(errorData) {
    const payload = {
      type: "javascript_error",
      timestamp: new Date().toISOString(),
      app: this.appName,
      environment: this.environment,
      ...errorData,
    };

    try {
      const response = await fetch(this.logstashUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        console.error(
          "Erreur lors de l'envoi du log à Logstash:",
          response.status
        );
      }
    } catch (error) {
      console.error("Erreur lors de l'envoi du log à Logstash:", error);
    }
  }

  /**
   * Envoie un événement personnalisé à Logstash
   * @param {string} eventType - Type d'événement
   * @param {Object} eventData - Données de l'événement
   */
  async logEvent(eventType, eventData) {
    const payload = {
      type: "user_event",
      event_type: eventType,
      timestamp: new Date().toISOString(),
      app: this.appName,
      environment: this.environment,
      ...eventData,
    };

    try {
      const response = await fetch(this.logstashUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        console.error(
          "Erreur lors de l'envoi de l'événement à Logstash:",
          response.status
        );
      }
    } catch (error) {
      console.error("Erreur lors de l'envoi de l'événement à Logstash:", error);
    }
  }
}

// Exporter la classe pour utilisation dans d'autres modules
if (typeof module !== "undefined" && module.exports) {
  module.exports = LogstashPipe;
} else if (typeof window !== "undefined") {
  window.LogstashPipe = LogstashPipe;
}
